import {useState, useContext} from "react"
import {UpdateUserContext} from "../../App"
import {color_note} from "../Fonctions"


export function PPP001 ({auth, setShow_activite, setTab, data_eval, setData_eval}) {
  
  const updateUsercontext = useContext(UpdateUserContext)

  const sendData = (auth, delay=0) => {
    //console.log(auth)
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
        method: 'POST',
        body: JSON.stringify({...auth, action:'sauvegarder', erreur:data_eval.erreur})
      })
      .then(response => response.json())
      .then(data => {
        //console.log(data)
        //return
        updateUsercontext()
        setShow_activite(false)
        setTab([])
      })
      .catch(err => console.log(err))
  }

  if(auth.replayable === false) {
    setTimeout(e => {sendData(auth)}, 3000)
  }

  const handleClick = (e) => {
    sendData(auth)
  }

  //console.log(auth)
  //console.log(data_eval)
  return (<>
    <div className="page" >
      <div>
      <h1>Fin de l'activité</h1>
      <br/>
    	<div align="center">Fin de la série de {auth.nb_question} questions de niveau {auth.etoile} des activités suivantes :</div>
      <br/>
      <div className="cadre" style={{left:"50%", transform:"translateX(-50%)"}} dangerouslySetInnerHTML={{ __html:auth.title || auth.activite.replaceAll('__', '<br>')}}></div>
      <br/>

      {auth.profil === 'Professeur' ?
        <><input type="button" className="btn" value="Correction" onClick={()=>setData_eval({...data_eval, elt_co:!data_eval.elt_co})} />
          <div className="precedent" onClick={()=>setData_eval({...data_eval, page:data_eval.page-1})}></div>
        </>
        :
        <><div align="center">
          Vous avez obtenu 
          <div className={color_note(auth.note)} style={{fontSize:'1.5em', margin:'10px 0'}} >{auth.note}%</div> 
          de réussite.
          </div>
          <br/>
          {auth.replayable !== false && auth.nom ? <input type="button" className="btn" value="Sauvegarder" onClick={handleClick} /> : ''}
        </>
      }
      </div>
      {auth.replayable !== false && 
        <input type="button" className="btn" value="Retour" onClick={() => {
          setShow_activite(false)
          setTab([])
        }} />
      }
      <br/><br/>
    </div>
    
    </>
  );
}